import { LICENSE_TYPES, type LicenseType } from './types'

export function findLicenseTypeById(licenseTypeId: string): LicenseType | undefined {
    return Object.values(LICENSE_TYPES).find((licenseType) => licenseType.id === licenseTypeId)
}
